import React from 'react';

export default function Footer() {
  return (
    <div className="footer">
      <p>© 2024 Robert Baufeld. All rights reserved.</p>
      <a href="https://robertlikescoding.github.io/portfolio/">RobertLikesCoding</a>
    </div>
  )
}